export const nowInSeconds = () => Date.now() / 1000
